/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.article-note.service.ts.
 */
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfigService} from './app.config.service';
import {Artikel} from '../models/artikel';
import {ArtikelNote} from '../models/artikel-note';
import {BehaviorSubject} from 'rxjs';
import {AppSettingsService} from './app.app_settings.service';

/**
 * Zweck: Beschreibt class AppArticleNoteService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppArticleNoteService {
  show_inline = new BehaviorSubject<boolean>(null);

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private http: HttpClient, private cfg: AppConfigService, private sett: AppSettingsService) {
    this.sett.getUserSettingValue('ShopViewArticleNoteInline').subscribe(s => this.show_inline.next(s));
  }

/**
 * Beschreibt Methode getForArticle und ihren Rückgabevertrag.
 */
  getForArticle(art: Artikel) {
    return this.http.get<ArtikelNote>(
      '/artikelnote/getByArtnr/' + art.Artikelstamm + '/' + art.ArtikelNummer
    );
  }

/**
 * Beschreibt Methode setForArticle und ihren Rückgabevertrag.
 */
  setForArticle(art: Artikel, note: ArtikelNote) {
    return this.http.post<ArtikelNote>(
      '/artikelnote/setByArtnr/' + art.Artikelstamm + '/' + art.ArtikelNummer,
      {
        artikelnote: note.note
      }
    );
  }

/**
 * Beschreibt Methode deleteForArticle und ihren Rückgabevertrag.
 */
  deleteForArticle(art: Artikel, note: ArtikelNote) {
    return this.http.get<ArtikelNote>(
      '/artikelnote/deleteByArtnr/' + art.Artikelstamm + '/' + art.ArtikelNummer,
    );
  }
}
